import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
class RemoteWorkHeaderComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "remote-work-header-component",
            children: /*#__PURE__*/ _jsx(BaseHeaderComponent, {})
        });
    }
}
export { RemoteWorkHeaderComponent as default };
RemoteWorkHeaderComponent.defaultProps = {};
